import React, { useEffect, useState } from "react";
import { Row, Column, Grid } from 'carbon-components-react';
import { useFormContext } from 'react-hook-form';
import FormInput from "../../components/form_elements/form-input";
import FormDatePicker from "../../components/form_elements/form-date-picker";
import FormDropdown from "../../components/form_elements/form-dropdown";
import { useSelector } from "react-redux";
import {parseISO, isBefore, sub,format } from "date-fns";
import { AttachmentType } from "../../components/enums/attachment-type";
import Attachment from "../../components/attachment";
import { DependentRelationship } from "../../components/enums/dependent-relationship";
import { DependentIsChildAndOlderThan27, isDomesticPartnerAffidavitRequired, isProofOfDisabilityRequired } from "../../components/attachment-validator";
import FormCheckbox from "../../components/form_elements/form-checkbox";


const DependentForm = ({dependent, setDependent, show, relationships, dependents, attachments, setAttachments}) => {
    const {setValue, reset, watch, trigger} = useFormContext();
    const [genders, setGenders] = useState([]);
    const [isDependent, setIsDependent] = useState([]);
    const enrollments = useSelector(s => s.enrollments);
    const RelationshipId = watch("relationshipId");
    const Birthdate = watch("birthdate");

    const [filteredRelationships, setFilteredRelationships] = useState([]);
    const [filteredContacts, setFilteredContacts] = useState([]);
    const [showDomesticPartnerAffidavit, setShowDomesticPartnerAffidavit] = useState();
    const [showProofOfDisability, setShowProofOfDisability] = useState();

    useEffect(() => {
        if(!show){
            reset();
            setValue("dependent",null);
            setIsDependent(null);
            return;
        }
        if (Array.isArray(enrollments)) 
            return;

        const birthdate = dependent?.birthdate ? parseISO(dependent?.birthdate): null;
        setValue("firstName", dependent.firstName);
        setValue("lastName", dependent?.lastName);
        setValue("ssn", dependent?.ssn);
        setValue("birthdate", birthdate);
        setGenders(enrollments?.genders);
        setValue("genderId", dependent?.gender?.id);
        setValue("relationshipId", dependent?.relationship?.id);
        setValue("disabledFile", dependent.disabledFile);
        setValue("hasDisability",dependent?.hasDisability); 

        filterContacts();
        const unmodifiedContact = enrollments.contacts.find(s => s.id === dependent.id);
        getDomesticPartnerAffidavitStatus(dependent?.relationship?.id, unmodifiedContact);
        getProofOfDisabilityStatus(dependent?.relationship?.id, birthdate, unmodifiedContact);

            
    }, [show]);

    
  useEffect(() => {
    if(relationships){
        const isSpouse = dependent?.relationship?.id === DependentRelationship.Spouse;
        const hasSpouse = dependents?.some(s => s.relationship.id === DependentRelationship.Spouse);
       if(!isSpouse && hasSpouse)
            setFilteredRelationships(relationships?.filter(s => s.id !== DependentRelationship.Spouse));
        else
            setFilteredRelationships(relationships);

    }
      
  }, [relationships, show]);

    const getDomesticPartnerAffidavitStatus = (relationshpId, unmodifiedContact) => {
        const affidavitRequired = isDomesticPartnerAffidavitRequired(relationshpId, unmodifiedContact, dependent?.id);
        
        setShowDomesticPartnerAffidavit(affidavitRequired);
    }

    const getProofOfDisabilityStatus = (relationshipId, birthDate, unmodifiedContact) => {
        const isChildDisabled = DependentIsChildAndOlderThan27(birthDate, relationshipId);
        const proofOfDisabilityRequired = isProofOfDisabilityRequired(relationshipId, birthDate, unmodifiedContact, dependent?.id);

        setValue("hasDisability", isChildDisabled); 
        setShowProofOfDisability(proofOfDisabilityRequired);
    }

    const relationshipChange = (e) => {
        const unmodifiedContact = enrollments.contacts.find(s => s.id === dependent.id);

        getDomesticPartnerAffidavitStatus(e.selectedItem?.id, unmodifiedContact);
        getProofOfDisabilityStatus(e.selectedItem?.id, Birthdate, unmodifiedContact);
    }

    const birthdateChange = (e) => {
        const unmodifiedContact = enrollments.contacts.find(s => s.id === dependent.id);

        getProofOfDisabilityStatus(RelationshipId, e, unmodifiedContact)
    }


    const populateFields = (person) => {
        
        setIsDependent(enrollments?.contacts?.some((s) => s?.id === person?.id));
        setDependent(person);
        const birthdate = person?.birthdate ? parseISO(person?.birthdate): null;

        setValue("id", person?.id);
        setValue("firstName", person?.firstName);
        setValue("lastName", person?.lastName);
        setValue("relationshipId", person?.relationship?.id);
        setValue("genderId", person?.gender?.id);
        setValue("birthdate", birthdate);
        setValue("ssn", person?.ssn);
    }


    const filterContacts = () => {
        const contactDependents = enrollments?.contacts?.filter(s=> DependentRelationship.All.includes(s.relationship.id));
        const unenrolledDependents = contactDependents.filter(s => !enrollments.dependents.includes(s.id));
        
        setFilteredContacts(unenrolledDependents);
    }

    return(
        
        <Grid narrow className="mb-16">
        {
            filteredContacts.length > 0  && !dependent?.id ? 
            <>
                <Row>
                <Column>
                    <FormDropdown
                    onChange={(e) => {
                        populateFields(e?.selectedItem);
                    }}
                    itemToString={(item) => item?.firstName + " " + item?.lastName}
                    label="Select from contacts"
                    name="dependent"
                    items={filteredContacts}
                    />
                </Column>
                </Row>
                <div>
                    <div className="mb-4">OR</div>
                </div>
                <Row>
                    <Column className="mb-3 text-xs">
                    Create New Record
                    </Column>
                </Row>

            </>
            : <></>
        }
        
            <Row>
                <Column>
                    <FormInput name="firstName" label="First Name *"  props={{ maxLength: "25" }} />
                </Column>
            </Row>
            <Row>
                <Column>
                    <FormInput name="lastName" label="Last Name *"  props={{ maxLength: "25" }} />
                </Column>
            </Row>
            <Row>
                <Column>
                    <FormDropdown label="Relationship *" name="relationshipId" items={filteredRelationships} onChange={relationshipChange}/>
                    <Attachment 
                        show={showDomesticPartnerAffidavit} 
                        attachmentType={AttachmentType.DpAffidavit} 
                        name="domesticFile" 
                        buttonLabel="Upload affidavit (PDF file)" 
                        labelDescription={<span>Please upload Domestic Partnership Affidavit (<a href="https://stclaycopublicfiles.blob.core.windows.net/employee-benefits/DomesticPartnershipAffidavit.pdf" target="_blank">Download</a>)</span>} 
                        label="An affidavit is required for a domestic partnership"
                        setAttachments={setAttachments}
                        attachments={attachments}
                    />
                </Column>
            </Row>
            <Row>
                <Column>
                    <FormDropdown label="Gender *" name="genderId" items={genders} />
                </Column>
            </Row>
            <Row>
                <Column>
                    <FormDatePicker name="birthdate" label="Date of Birth *" onChange={birthdateChange}  minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 100)).toLocaleDateString()} maxDate={new Date().toLocaleDateString()} />
                    <Attachment 
                        show={showProofOfDisability} 
                        attachmentType={AttachmentType.ProofOfDisability} 
                        name="disabledFile"
                        buttonLabel="Upload Documentation (PDF file)"
                        labelDescription="Please upload supporting documentation showing proof of disability" 
                        label="Dependents older than 26 cannot be added unless disabled."
                        setAttachments={setAttachments}
                        attachments={attachments}
                    />
                </Column>
            </Row>
            <Row>
                <Column className="mt-6">
                    <FormInput name="ssn" type="ssn" label="Socal Security Number *" />
                    <FormCheckbox name="noSsn" label="This dependent does not currently have a SSN" onChange={() => {trigger("ssn")}} />
                </Column>
            </Row>
        </Grid>     
        
    )
}

export default DependentForm;

